module.exports = __webpack_public_path__ + "img/5.28250a81.jpg";